<template>
  <div id="cms-page">
    <div v-if="pageLayout === '2columns-left'" class="col-xs-12 container col-md-12 p0">
      <breadcrumbs
        class="center-xs cl-silver breadcrumbs"
        :routes="[{name: 'Home', route_link: '/'}]"
        :active-route="cmsPageContent.title"
      />
    </div>
    <header v-if="pageLayout !== 'empty' && pageLayout !== '2columns-left'" class="bg-cl-secondary py35">
      <div class="container">
        <div class="row middle-sm middle-xs">
          <div class="col-xs-2 flex middle-xs center-xs mt10 pointer" @click="goBack()">
            <i class="icon-chevron-left back-btn" />
          </div>
          <h1 class="col-xs-10 category-title my10">
            {{ cmsPageContent.title }}
          </h1>
        </div>
      </div>
    </header>
    <div class="cms_content" v-html="cmsPageContent.content" />
  </div>
</template>

<script>
import CmsPage from '@vue-storefront/core/pages/CmsPage'
import { htmlDecode } from '@vue-storefront/core/filters/html-decode'
import Breadcrumbs from 'theme/components/core/Breadcrumbs.vue'
import config from 'config'
import { isServer } from '@vue-storefront/core/helpers'

export default {
  components: {
    Breadcrumbs
  },
  computed: {
    cmsPageContent () {
      return this.$store.state.cmsPage.current
    },
    pageLayout () {
      return this.$store.state.cmsPage.current ? this.$store.state.cmsPage.current.page_layout : ''
    },
    iframeSlug () {
      const pageUrl = 'https://blogcms.egarderobe.pl'
      const pageSlug = this.cmsPageContent.content.replace(/<\/?p>/g, '')
      return pageUrl + pageSlug
    }
  },
  methods: {
    goBack () {
      if (this.to) {
        this.$router.push(this.to)
      } else {
        this.$router.back()
      }
    }
  },
  mixins: [CmsPage],
  beforeRouteEnter (to, from, next) {
    if (isServer) {
      next()
    } else {
      next(vm => {
        vm.$store.commit('ui/routeChanged', { to: to, from: from })
      })
    }
  },
  metaInfo () {
    return {
      htmlAttrs: { lang: config.storeViews[this.$store.state.storeView.storeCode].i18n.defaultLocale },
      title: htmlDecode(this.pageTitle || this.$route.meta.title),
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: htmlDecode(this.pageDescription || this.$route.meta.description) 
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: htmlDecode(this.pageKeywords)
        },
        {
          vmid: this.$store.state.cmsPage.current.meta_keywords ? 'og:image' : '',
          property: this.$store.state.cmsPage.current.meta_keywords ? 'og:image' : '',
          content: this.$store.state.cmsPage.current.meta_keywords ? this.$store.state.cmsPage.current.meta_keywords : ''
        },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: htmlDecode(this.pageTitle || this.$route.meta.title)
        },
        {
          vmid: 'og:locale',
          property: 'og:locale',
          content: this.$store.state.storeView.storeCode ? config.storeViews[this.$store.state.storeView.storeCode].i18n.defaultLocale : ''
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content: htmlDecode(this.pageDescription || this.$route.meta.description)
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.back-btn {
  border: 1px solid;
  border-radius: 50%;
  padding: 12px 18px;
  font-size: 18px;
}
.cms_content /deep/ .kontakt-border {
  @media (max-width: 767px) {
    border-right: 0px solid black;
    padding-right: 0px;
  }
}
.cms_content /deep/ .kontakt-text-box {
  @media (max-width: 767px) {
    padding-left: 0px;
}
}
// .cms_content /deep/ .o-nas_section {
//   @media (max-width: 767px) {
//     flex-direction: column;
//     .o-nas {
//       order: 1;
//       padding-left: 0px;
//     }
//     .o-nas1 {
//       padding-right: 0px;
//     }
//     .image-order-mobile {
//       order: 2;
//     }
//     .image2 {
//       display: none;
//     }
//     .o-nas-employee {
//       padding-left: 0px;
//     }
//     .onas-title-employee {
//       padding-left: 50px;
//       font-size: 20px;
//     }
//     .onas-small-text {
//       padding-left: 50px;
//       font-size: 12px;
//     }
//     .employee-image {
//       padding-left: 50px;
//       padding-right: 50px;
//     }
//   }
// }
// .cms_content /deep/ .onas-text {
//     @media (max-width: 767px) {
//       font-size: 12px;
//       padding-left: 50px;
//       padding-right: 50px;
//     }
// }
// .cms_content /deep/ .onas-title {
//     @media (max-width: 767px) {
//       font-size: 22px;
//       text-align: left;
//       padding-left: 50px;
//       padding-right: 50px;
//     }
// }
// .cms_content /deep/ .employee-title {
//   @media (max-width: 767px) {
//     text-align: center;
//   }
// }
.breadcrumbs {
  padding-top: 30px;
  justify-content: center;
    /deep/ .opacity-breadcrubms {
    color: white;
  }
}
#wordpress-page {
  max-height: calc(100vh - 128px);
  @media (max-width: 1024px) {
    max-height: calc(100vh - 62px);
  }
}
</style>
